import { useMemo } from 'react'
import { useValueLabels } from '~/api/hooks/useCatalog'

const SEP = '\x1F' // ASCII unit separator — cannot occur in dim names or DB value tokens

/** (dim, value) -> display label for caption lines; raw value as the visible fallback.
 *  Render-only (V1 invariant) — mirrors useSeriesBaseLabels but keyed per-dim so caption
 *  lines across MULTIPLE filter dims resolve correctly. */
export function useDimValueLabelFor(factTable: string): (dim: string, value: string) => string {
  const valueLabels = useValueLabels(factTable)
  return useMemo(() => {
    const map = new Map<string, string>()
    for (const r of valueLabels.data ?? []) {
      if (r.display_label) map.set(`${r.dim_name}${SEP}${r.value}`, r.display_label)
    }
    return (dim: string, value: string) => map.get(`${dim}${SEP}${value}`) ?? value
  }, [valueLabels.data])
}
